export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9658.d9c61768.jpg";